export default {
  dicCateId: 'dicCateId',
  value: 'value',
  dictItem: 'dictItem',
  dictType: 'dictType',
}
